import { useAppSelector } from 'src/redux/hooks';
import { GlobalState } from 'src/redux/store';

export const countriesSelector = (state: GlobalState) => state.countries;

export const countriesSelectorData = (state: GlobalState) => countriesSelector(state).data;

export const useCountries = () => useAppSelector(countriesSelectorData);
